import LocalModal from 'components/base/local-modal';
import React from 'react';
import lightningImage from 'assets/images/lightning.png';
import { Button } from '@cokitchen/cokitchen-components';

type Props = {
  open: boolean;
  onRemove: () => void;
  onClose: () => void;
};

const QuickEatsModal = (props: Props) => {
  const { open, onRemove, onClose } = props;

  return (
    <LocalModal isOpen={open} onRequestClose={onClose} contentClassName='!w-96'>
      <div className='w-full flex flex-col gap-6'>
        <img src={lightningImage} className='w-[75px] mx-auto' />
        <article className='flex flex-col gap-2 text-center'>
          <p className='font-medium'>Heads Up!</p>
          <p className='text-sm text-gray-9'>
            Adding other restaurants to your Quick Eats order may increase your preparation time.
          </p>
        </article>
        <Button variant='block' color='primary' className='h-12' onClick={onClose}>
          Ok
        </Button>
        <Button
          variant='outline'
          color='gray'
          className='h-12 !border-gray-2 hover:!bg-gray-11'
          onClick={onRemove}>
          Remove other items
        </Button>
      </div>
    </LocalModal>
  );
};

export default QuickEatsModal;
